
import { useState } from 'react';
import r from 'render-dom';
import styled from 'styled-components';

import Button from 'components/App/Dashboard/ui/Button';
import AccountModal from 'components/shared/AccountSetup';
import WistiaVideoPlayer from 'components/shared/WistiaVideoPlayer';
import { appName } from 'constants/settings';
import { targetBlank } from 'utils/helpers';

const Container = styled.section`
    align-items: center;
    display: flex;
    height: 100vh;
    justify-content: center;
    margin: auto;

    & h1 {
        margin-top: 0;
    }

    & p {
        line-height: 1.5;
        margin-bottom: 30px;
    }

    & section {
        max-width: 700px;
    }
`;

export default function ExtensionUpgrade() {
    const extensionLink = 'https://chrome.google.com/webstore/detail/massview-extension/hhjcpkogjanjllhlfbedpemcckahkjhn?hl=en&gl=US';
    const [showAccountModal, setShowAccountModal] = useState(false);

    return (
        r.div([
            r(AccountModal, {
                isRendered: showAccountModal,
                onClose: () => setShowAccountModal(false),
            }),
            r(Container, [
                r.section([
                    r.h1([`Welcome to ${appName}!`]),
                    r.h4(['Your current plan only has access to the Monocle Chrome extension.']),
                    r.p([
                        `Install the Chrome extension to start automatically requesting reviews for your
                        orders in Seller Central. To gain access to Competitor Insight,
                        Peek DB, Keyword tracking & more, upgrade to a monthly plan.`
                    ]),
                    r(WistiaVideoPlayer, { showThumbnail: true, videoId: 'nagsdjfcp2' }),
                    r(Button, {
                        label: 'Upgrade Plan',
                        onClick: () => setShowAccountModal(true),
                        primary: true,
                    }),
                    r(Button, {
                        ...targetBlank(extensionLink),
                        label: 'Download Chrome Extension',
                    }),
                ]),
            ]),
        ])
    );
}
